import { createSlice } from '@reduxjs/toolkit';

import { updateVideoResources } from '@/modules/common/helpers/videoCache';

const initialState = {
  isLoading: true,
  playerPropsPassThrow: {},
  playlist: [],
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'singleVideo',
  initialState,
  reducers: {
    singleVideoFetchStartedAction: (state) => {
      state.isLoading = true;
    },
    singleVideoFetchSuccessAction: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });

      state.isLoading = false;
    },
    singleVideoFetchErrorAction: (state) => {
      state.isLoading = false;
    },
    singleVideoClearAction: () => initialState,
    updateSocialMetricAction: (state, action) => {
      state.playlist.forEach((video) => {
        if (video.mediaid === action.payload.mediaid) {
          Object.entries(action.payload.parameters).forEach(([key, value]) => {
            const item = video.performanceData.parameters.find((item$) => item$.type === key);

            if (item) {
              item.value = value;
            }
          });
        }
      });
    },
    updateResourceAction: (state, action) => {
      state.playlist.forEach((video) => {
        updateVideoResources(video, action.payload);
      });
    },
  },
});

export const {
  singleVideoClearAction,
  singleVideoFetchErrorAction,
  singleVideoFetchStartedAction,
  singleVideoFetchSuccessAction,
  updateSocialMetricAction,
  updateResourceAction,
} = slice.actions;
